import Title from 'antd/es/typography/Title';
import { Footer } from '../../components/Footer';
import './policy.scss';

function PrivacyPolicy() {
  return (
    <>
      <div
        className="policy-content"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/image/policy-bg.png)` }}
      >
        {/* <Title style={{ color: 'white' }}>隐私政策</Title> */}
        <div style={{ width: '100%', paddingTop: 12 }}>
          <span style={{ color: '#621ECE', paddingLeft: 12, fontSize: 16 }}>
            《桃高乐隐私政策》2026年6月10日生效版本
          </span>
        </div>
        <p
          style={{
            color: '#191430',
            whiteSpace: 'pre-line',
            paddingInline: 12,
            paddingBottom: 12,
            marginInline: 12,
            marginBottom: 12,
            fontSize: 13,
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderRadius: 12,
            border: '1px solid #ffffff',
          }}
        >
          <p style={{ color: '#621ECE', textAlign: 'center', fontSize: 16 }}>【特别提示】</p>
          {`本政策仅适用于广州市桃高网络科技有限公司及其关联公司（以下或称“我们”或“桃高”或“桃高乐”或“桃高”）提供的产品和服务及其延伸的功能（以下简称“桃高服务”），包括桃高乐APP、网站、客户端、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。如我们提供的某款产品有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品的隐私政策将优先适用，该款产品隐私政策和用户服务协议未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了桃高乐提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。
请仔细阅读《桃高乐隐私政策》并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可通过《桃高乐隐私政策》中的联系方式咨询我们。
版本更新日期：2026年6月10日
版本生效日期：2026年6月10日
如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：
联系邮箱：service@taogao88.com
引言
欢迎您使用桃高乐！我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《桃高乐隐私政策》（“本隐私政策”）向您说明在您使用我们的产品与/或服务时我们如何收集、使用、保存、共享和转移这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式
本隐私政策将帮助您了解以下内容：
一、我们如何收集和使用您的个人信息
二、我们如何使用Cookies和同类技术
三、我们如何保护和保存您的个人信息
四、您如何管理个人信息
五、未成年人的个人信息保护
六、通知和修订
七、如何联系我们
八、账户注销
本隐私政策与您所使用的桃高乐服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。
一、我们如何收集和使用您的个人信息
个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息。如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。
（一）您须授权我们收集和使用您个人信息的情形
我们的产品与/或服务包括一些核心功能，这些功能包含了实现网上购物所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：
1、实现网上购物所必须的功能
账号注册、登录与验证
当您注册桃高乐账号时，您至少需要向我们提供您准备使用的桃高乐手机号码，
您的账号名为系统随机生成，您可以修改和补充您的昵称
，这些信息均属于您的“账号信息”。
当您成功注册桃高乐账号后，可以使用桃高乐账号登录“桃高乐”App，登录时您需要向我们提供您的桃高乐账号信息。若您不提供这类信息，您将无法登录和在“桃高乐”App购买商品，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。
下单及订单管理
当您准备对商品进行结算时，桃高乐系统会生成您购买商品的订单。您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式；您可以另外填写收货人的联系电话、邮箱地址信息以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。若您需要开具发票，还需要提供发票抬头、纳税人识别号以及接收发票的电子邮箱，请您联系桃高乐的工作人员获取发票。
上述所有信息构成您的“订单信息”，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
支付功能
在您下单后，您可以选择桃高乐的关联方或与桃高乐合作的第三方支付机构（包括微信支付及支付宝支付通道，以下称“支付机构”）所提供的支付服务。我们需要将您的桃高乐订单号与交易金额信息与这些支付机构共享以完成下单支付功能。在您使用支付功能时，支付机构会通过其页面收集或验证您的银行卡（含储蓄卡、信用卡）及其他支付必要信息，以实现其确认您的支付指令并完成支付，具体适用各支付机构相应的隐私政策。为便于您正常使用钱包功能，您开通、使用桃高乐钱包的账户金额信息会在相应的支付机构页面展示。
交付产品与/或服务功能
在当您下单并选择货到付款或在线完成支付，或选择获取试用品、奖品后，桃高乐、桃高乐的关联方、供应商、与桃高乐合作的商家或第三方配送公司（以下称“配送公司”）将为您完成订单的交付。您知晓并同意，桃高乐、桃高乐的关联方、供应商、与桃高乐合作的商家或配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。
2、保障交易安全所必须的功能
为保障您使用我们的产品与/或服务时系统的稳定性和安全性，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们需要收集您的设备信息（设备型号、设备Mac地址、设备识别码、设备序列号、操作系统及软件版本、设备状态、网络状况）、日志信息、IP地址、浏览信息、订单信息、ssid、WiFi信息、IMSI、SIM卡信息（SIM序列号、运营商和国家码）来识别是否为真实自然人用户、是否为异常地点登录、判断您的账号风险；我们也会收集您的设备信息用于对桃高乐系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用桃高乐服务过程中对您的服务及账号安全进行保护。
（二）您可自主选择提供的个人信息的情形
为使您购物更便捷或更有乐趣，从而提升您在桃高乐的网上购物体验，我们在扩展功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用为您带来购物乐趣的扩展功能或在购买某些商品时需要重复填写一些信息。关于这些扩展功能收集的信息和使用目的，详见下方：
（1）基于位置信息的个性化推荐功能：我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您推荐您所在区域可以购买的商品或服务。
（2）基于图片上传的附加功能：您可以在桃高乐上传您的照片来实现拍照购物功能和晒单及评价功能，我们会使用您所上传的照片来识别您需要购买的商品或使用包含您所上传图片的评价。
（3）基于相机/摄像头的附加功能：您可以在开启相机/摄像头权限后使用该功能进行拍摄照片或视频用于商品和服务的评价、分享或设置账户头像。
（4）基于语音技术的附加功能：您可以直接使用麦克风来进行语音购物或与我们的客服机器人进行咨询和互动。在这些功能中我们会收集您的录音内容以识别您购物需求和客服与售后需求。
（5）基于日历的附加服务：在您开启我们可读取/写入您日历的权限后，我们将收集您的日历信息用于向您提供购物、促销活动或领取权益相关记录及提醒。请您注意，我们仅会在以上情况下读取您购物相关的日历信息。
（6）基于本地存储的附加功能：为了提供更好的服务，我们在系统运行时需要记录相关信息到您手机的外部存储器中，需要您开启可读取/写入您存储的权限。您也可以在系统设置中关闭此权限。
（7）基于通讯录信息的附加功能：为了增加您使用桃高乐时的社交乐趣，在获得您的授权同意下我们获取您的通讯录用以判断您的好友是否也同为桃高乐用户，您可以通过邀请新用户在桃高乐平台进行购物或分享活动内容。此项功能您可以自行选择开启或关闭，一旦关闭您可能无法参与邀请新好友或分享的活动，但不会影响您使用桃高乐提供的其他服务。


上述附加功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相册（图片库）、相机/摄像头、麦克风、日历、存储、通讯录的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。
请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。

（三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
1、与国家安全、国防安全有关的；
2、与公共安全、公共卫生、重大公共利益有关的；
3、与犯罪侦查、起诉、审判和判决执行等有关的；
4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
5、所收集的个人信息是个人信息主体自行向社会公众公开的；
6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
7、根据您的要求签订合同所必需的；
8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
9、为合法的新闻报道所必需的；
10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
11、法律法规规定的其他情形。

（四）我们从第三方获得您个人信息的情形
我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意后将您的第三方账户与您的桃高乐账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
（五）您个人信息使用的规则
1、我们会根据本隐私政策的内容，为实现我们的产品与/或服务功能对所收集的个人信息进行使用。
2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理。
3、当我们展示您的个人信息时，我们会采用包括去标识化或者匿名化处理方式对您的信息进行脱敏，以保护您的信息安全。
4、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的明示同意。
请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本隐私政策中尚未列明的其他产品与/或服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您可能无法使用该项产品与/或服务，但不影响您使用现有产品与/或服务。
二、我们如何使用Cookies和同类技术
（一）Cookies的使用
1、为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账号或数据安全。
2、我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问桃高乐网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
（二）网络Beacon和同类技术的使用
除Cookies外，我们还会在网站上使用网络Beacon及其他同类技术。我们的网页上常会包含一些电子图像（称为\单像素\ GIF文件或\网络Beacon\）。我们使用网络Beacon的方式有：
（1）通过在桃高乐网站上使用网络Beacon，计算用户访问数量，并通过访问Cookies辨认注册的桃高乐用户。
（2）通过得到的Cookies信息，为您提供个性化服务。
三、我们如何保护和保存您的个人信息
（一）我们保护您个人信息的技术与措施
我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
1、数据安全技术措施
我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。例如：桃高乐的网络服务采取了传输层安全协议加密技术，通过https方式提供浏览服务，确保用户数据在传输过程中的安全；桃高乐采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离；在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性；桃高乐采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；桃高乐采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。
2、桃高乐为保护个人信息采取的其他安全措施
我们仅允许有必要知晓这些信息的桃高乐及桃高乐关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。
互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。在通过桃高乐与第三方进行网上产品与/或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
（二）您个人信息的保存
1、您的个人信息将存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独获取您的授权同意并要求接收方按照双方签署的数据保护协议、本隐私政策以及相关法律法规要求来处理您的个人信息。
2、在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。
3、请您注意，当您成功注销桃高乐账号后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。
4、如果我们终止服务或运营，我们会至少提前七日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
四、您如何管理您的个人信息
桃高乐非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
1、访问和更正您的个人信息
除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
（1）您的账号信息：移动端具体路径为：个人资料信息：首页--“我的”进入我的桃高乐--右上角进入账号设置。
（2）您的收货信息：移动端具体路径为：首页--“我的”进入我的桃高乐--我的地址管理。您也可以将最常用的收货地址设置为默认地址，如此，若您下次购买商品时未更改收货地址，您的商品会配送到该默认地址。
（3）您的订单信息：移动端具体路径为：移动端首页--“我的”进入我的桃高乐--我的订单/待发货/已发货。您可以选择删除已经完成和已取消的订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务。
（4）您的浏览信息：您可以访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。移动端路径为：搜索历史记录：首页--“商城”右上角搜索--清除浏览记录；
对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
2、删除您的个人信息
您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息、收货地址信息。
在以下情形中，您可以向我们提出删除个人信息的请求：
（1）如果我们处理个人信息的行为违反法律法规；
（2）如果我们收集、使用您的个人信息，却未征得您的同意；
（3）如果我们处理个人信息的行为严重违反了与您的约定；
（4）如果您不想再使用我们的产品或服务并提出申请后；
（5）如果我们终止服务及运营，或者保存期限已届满。
若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。
请您注意，当您成功注销桃高乐账号后（注销流程见下方第八条），我们将对您的个人信息进行删除或匿名化处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到可以删除或实现匿名化。
3、改变您授权同意的范围或撤回您的授权
您可以通过删除信息、关闭设备功能、在桃高乐网站或软件中进行隐私设置改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账号的方式（注销流程见下方第八条），撤回我们继续收集您个人信息的全部授权。
请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
4、获取您的个人信息副本
您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您随时联系我们。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供相应的个人信息副本。
5、响应您的请求
如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息或者获取个人信息副本，或您认为桃高乐存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件至service@taogao88.com或通过本隐私政策中的其他方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
五、未成年人的个人信息保护
1、我们不向未满18周岁的未成年提供服务，如果发现你是未成年人，我们有权停止账户使用。
六、通知和修订
1、为给您提供更好的服务以及随着桃高乐业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在桃高乐网站、桃高乐移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问桃高乐以便及时了解最新的隐私政策。
2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
本隐私政策所指的重大变更包括但不限于：
（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
（3）个人信息共享、转移或公开披露的主要对象发生变化；
（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
（6）个人信息安全影响评估报告表明存在高风险时。
3、我们还会将本隐私政策的旧版本存档，供您查阅。
4、为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在桃高乐APP通过“我的-账户设置-隐私政策”中查看本政策。
七、如何联系我们
1、如您对本隐私政策或您个人信息的相关事宜或者投诉、举报、有任何问题、意见或建议，请通过以下方式与我们联系。
个人信息保护负责人邮箱service@taogao88.com
您还可以随时通过App内直接添加客服微信多种方式与我们联系。
2、一般情况下，我们将在15个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商监管部门进行投诉或举报。
附：个人信息及敏感个人信息示例（非桃高乐APP或网站所收集的个人信息，仅作示例说明）
个人信息：是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
敏感个人信息：是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
设备信息：包括设备识别码（IMEI、IDFA、Android ID、MAC、OAID、IMSI及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息），设备网络环境信息（IP地址，WiFi信息，基站信息及其他网络相关信息）。
八、账户注销
桃高乐提供完整的用户信息防护以及账户注销服务，您可以通过以下2种方式注销您的账户。
1、如您不需要我们继续为您提供服务，您可以通过我们为您提供的移动端App(Android/iOS)的个人中心\我的\右上角设置按钮进入，进入\注销账户\模块。在仔细确认注销前注意事项后，点击\确认注销\，我们将在接受到您\账户注销\请求后的5个工作日内对您的账户完成数据清除，届时将不再另行通知。
2、发送邮件至service@taogao88.com提出您的账户注销申请。
在完成注销操作服务前您的账户还可正常使用。

桃高乐应用内的一切商业活动与Apple inc无关。如有任何玩法疑问的，可以发送电子邮件到service@taogao88.com邮箱或者在线客服咨询。`}
        </p>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
